import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { FastCommentsCommentWidget } from 'fastcomments-react';

import useThunktank from '@tmap/mmm-core/redux/thunktank/useThunktank';

import { Alert } from '@tmap/mmm-style-guide/src/Alert';
import { Box } from '@tmap/mmm-style-guide/src/Box';

import useCurrentUser from '../hooks/useCurrentUser';
import { getCommentToken } from '../actions/community';
import useRequireAuth from '../hooks/useRequireAuth';

function CommentsWidget(props) {
  const { contentId, ...otherProps } = props;

  const { isAuthenticated } = useRequireAuth();
  const user = useCurrentUser();
  const useThunk = useThunktank('commentToken');
  const [tokenState, getToken] = useThunk(getCommentToken);
  const { data: commentToken, error } = tokenState;

  const router = useRouter();

  useEffect(() => {
    if (user && Object.keys(user).length > 0) {
      getToken(contentId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, contentId]);

  if (error) {
    return (
      <Box style={{ padding: '55px 0' }}>
        <Alert severity='warning'>Comments are currently unavailable.</Alert>
      </Box>
    );
  }

  const urlId = router.asPath.match(/^[^#?]+/)[0]; // match up to # or ?

  return (
    (!isAuthenticated || commentToken) && (
      <FastCommentsCommentWidget
        tenantId={process.env.NEXT_PUBLIC_FASTCOMMENTS_TENANT_ID}
        urlId={urlId}
        sso={commentToken || { loginURL: `/login?r=${router.asPath}` }}
        inputAfterComments
        customCSS={`.comment-reply.root { padding: 15px; }
        .comments-toggle { background:unset; color:#000; font-size:14px; width:inherit; margin:inherit; padding:14px 14px 0px; }
        .comments-toggle.toggle-hide-comments::after { content:' ^'; }
        .comments-toggle.toggle-show-comments::after { font-weight:bolder; font-size:larger; content:' ˅'; }
        .comment { margin-top:inherit; }
        .comment > .inner > .comment-bottom { margin-top:24px; }
        .footer { margin:0; padding:0; height:0; }
        .footer:not(.empty) {
          border-top:unset;
        }
        .comments { padding-bottom: 212px; margin-bottom: -200px }
      `}
        {...otherProps}
      />
    )
  );
}

export default CommentsWidget;
